import { useEffect, useState } from 'react';

const navLinks = [
  { href: '#hot', label: '热门连载' },
  { href: '#updates', label: '最新更新' },
  { href: '#ranking', label: '人气榜单' },
  { href: '#genres', label: '题材分类' },
  { href: '#feature', label: '阅读体验' },
  { href: '#faq', label: '常见问题' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState('');

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (!keyword.trim()) return;
    // 示例搜索：滚动到热门连载区
    document.getElementById('hot')?.scrollIntoView({ behavior: 'smooth' });
    setKeyword('');
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur border-b border-background-300/50' : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 items-center justify-between gap-4 px-4 md:px-6 lg:px-8">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-open-fill text-lg" />
          </span>
          <span className="font-heading text-xl text-foreground-950">
            YY<span className="text-primary-500">漫画</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-600 transition hover:bg-background-100 hover:text-primary-500"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <form onSubmit={handleSearch} className="hidden items-center gap-2 md:flex" role="search" aria-label="站内搜索">
          <label className="flex items-center gap-2 rounded-full border border-background-300 bg-background-100/70 px-3 py-1.5">
            <i className="ri-search-line text-sm text-foreground-500" />
            <input
              type="search"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索漫画 / 作者"
              aria-label="搜索漫画"
              className="w-36 bg-transparent text-sm text-foreground-950 outline-none placeholder:text-foreground-500 lg:w-44"
            />
          </label>
          <button
            type="submit"
            className="flex h-9 w-9 items-center justify-center whitespace-nowrap rounded-full bg-secondary-500 text-background-50 transition hover:bg-secondary-600"
            aria-label="搜索"
          >
            <i className="ri-arrow-right-line text-sm" />
          </button>
        </form>

        <button
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-lg border border-background-300 bg-background-100/70 text-foreground-800 md:hidden"
          aria-label="打开菜单"
          aria-expanded={open}
        >
          <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
        </button>
      </div>

      {open && (
        <div className="border-t border-background-300/50 bg-background-50/95 px-4 py-3 backdrop-blur md:hidden">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-700 transition hover:bg-background-100 hover:text-primary-500"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <form onSubmit={handleSearch} className="mt-3 flex items-center gap-2" role="search">
            <label className="flex flex-1 items-center gap-2 rounded-full border border-background-300 bg-background-100/70 px-3 py-2">
              <i className="ri-search-line text-sm text-foreground-500" />
              <input
                type="search"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索漫画 / 作者"
                aria-label="搜索漫画"
                className="w-full bg-transparent text-sm text-foreground-950 outline-none placeholder:text-foreground-500"
              />
            </label>
            <button
              type="submit"
              className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary-500 text-background-50"
              aria-label="搜索"
            >
              <i className="ri-arrow-right-line text-sm" />
            </button>
          </form>
        </div>
      )}
    </header>
  );
}